module.exports = __webpack_public_path__ + "img/view_invoice.023c68fa.svg";